import P from 'prop-types';
import { useReducer } from 'react';
import { PaginationContext } from './context';
import { data } from './data';
import { reducer } from './reducer';

export const PaginationProvider = ({ children }) => {
  const [paginationState, paginationDispatch] = useReducer(reducer, data);

  return (
    <PaginationContext.Provider value={{ paginationState, paginationDispatch }}>
      {children}
    </PaginationContext.Provider>
  );
};

PaginationProvider.propTypes = {
  children: P.node.isRequired,
};
